import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import WhatsappIcon from '@/components/icons/WhatsappIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#bba595',
        secondary: '#8c3c03',
        accent: '#545251',
        error: '#f1afae',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
    values: {
      whatsapp: {
        component: WhatsappIcon,
      },
    },
  },
});
